import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectPublicLinkData,
  // selectPublicLinkData,
  selectShareProductPageData,
  setShareProductPage,
  setSharePublicLinkData,
} from '../../../redux/slicers/productV2Slicer';
import styles from './styles.module.scss';
import InfoDialogUI from '../../../components/InfoDialog/InfoDialogUI';
import { useEffect, useState } from 'react';
import { icons } from '../../../assets';
import { apiGet, GET_SEARCH_MEMBER_DETAIL, updateProductTrackingAnalytics, updateTextureTrackingAnalytics } from '../../../helpers/api';
import { objectToSearchParams } from '../../../helpers/jsHelper';
import { EmbedAndCopy, EmbedCode } from './Embed';
import { WhoHaveAccess } from './WhoHaveAccess';
import { InviteForm } from './InviteForm';
import PaymentDoneIcon from '../../../components/icons/PaymentDone';
import { BigButton, Loader } from '../../../common';
import { setContactFormDialogOpen } from '../../../redux/slicers/subscriptionSlicer';
import { ContactUs } from '../../subscriptionComponents/ContactUs';
import UpgradeCardBanner from './UpgradeCardBanner';
import useCurrentOrganizationInfo from '../../../hooks/useCurrentOrganizationInfo';
import { useUserContext } from '../../../contexts/UserContext';
import Switch from '../../../components/admin/switch';
import { warningToast } from '../../../helpers/toastHelper';
const { ArrowIconV2 } = icons;

export const PRODUCT_PAGE_SHARE_ACCESS_LABEL = {
  1: 'Can View',
  2: 'Can Edit',
  3: 'Remove',
};

export const PRODUCT_PAGE_SHARE_ACCESS = {
  CAN_VIEW: 1,
  CAN_EDIT: 2,
  REMOVE: 3,
};

export const WHO_CAN_ACCESS_PAGE_LABEL = {
  1: 'Only those who are invited',
  // 2: 'Only with "ORGANIZATION_NAME"',
  2: 'Anyone with the link, no sign-in required',
};

export const WHO_CAN_ACCESS_PAGE = {
  INVITED: 1,
  // ONLY_ORGANIZATION: 2,
  ANYONE: 2,
};

export const apiGetTheSharePage = ({ params = {}, page, perPage = 20 } = {}) => {
  const _params = objectToSearchParams({ ...params, page, per_page: perPage });

  return apiGet(`${GET_SEARCH_MEMBER_DETAIL}?${_params}`);
};

export const ShareProductPageModal = () => {
  const product = useSelector(selectShareProductPageData);
  if (!product) return null;
  return <ShareProductPageModalUI product={product} />;
};

const ShareProductPageModalUI = ({ product }) => {
  const dispatch = useDispatch();
  const { isFreemiumUser } = useCurrentOrganizationInfo();
  const publicLinkData = useSelector(selectPublicLinkData);
  const [showEmbedCodeView, setShowEmbedCodeView] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [isShareLoading, setIsShareLoading] = useState(false);
  const [trackingEnable, setTrackingEnable] = useState(false);
  const { name } = product || {};

  useEffect(() => {
    if(publicLinkData){
      trackingEnable !== publicLinkData?.tracking && setTrackingEnable(publicLinkData?.tracking)
    }
  }, [publicLinkData]);

  const handleClose = () => {
        setSuccessModal(false)
        dispatch(setShareProductPage(null))
  }

  const handleToggleChange = async () => {
    const payload = {
      tracking:!trackingEnable
    }
    const APIFun = publicLinkData?.product ? updateProductTrackingAnalytics : publicLinkData?.texture ? updateTextureTrackingAnalytics : ''
    if(publicLinkData?.product || publicLinkData?.texture){
      setIsShareLoading(true)
      const res =  await APIFun({id:publicLinkData?.unique_code, data:payload})
      if(res?.id){
        dispatch(setSharePublicLinkData({tracking:!trackingEnable}))
        setTrackingEnable(!trackingEnable)
      }else{
        warningToast("Something went to wrong")
      }
      setIsShareLoading(false)  
    }
  }

  return (
    <InfoDialogUI
      size="lg"
      show={true}
      onClose={handleClose}
      closeable={true}
      bodyClassName={styles.root}
      animation={true}>
      <div className={styles.wrapper}>
        {successModal ? (
          <>
            <SuccessModal name={name} list={successModal || []} handleClose={handleClose} />
            <ContactUs />
          </>
        ) : (
          <>
            <div className={styles.header}>
              <h2
                {...(showEmbedCodeView
                  ? {
                      className: 'cursor-pointer',
                      onClick: () => setShowEmbedCodeView(false),
                    }
                  : {})}>
                {showEmbedCodeView ? (
                  <>
                    <ArrowIconV2 className={styles.backIcon} />
                    <span>Get embed code</span>
                  </>
                ) : (
                  <>Share &quot;{name}&quot;</>
                )}
              </h2>
            </div>
            <div className={cx('w-100', showEmbedCodeView ? 'd-none' : '')}>
              <InviteForm setSuccessModal={setSuccessModal} product={product} className="mb-3" />
              <WhoHaveAccess product={product} className="mb-3" />
              {isFreemiumUser && <UpgradeCardBanner />}
              <EmbedAndCopy
                product={product}
                setShowEmbedCodeView={setShowEmbedCodeView}
                isDisabled={
                  +publicLinkData?.product_page_share_access === WHO_CAN_ACCESS_PAGE.INVITED
                }
                trackingEnable={trackingEnable}
              />
              <div className="d-flex mt-3 align-items-center">
                <span className="me-3">Enable tracking</span>
                {isShareLoading ? (
                  <div style={{ width: '10px' }} className="position-relative">
                    <Loader loading={true} size={20} thickness={2} />{' '}
                  </div>
                ) : (
                  <Switch disabled={false} checked={trackingEnable} onToggle={handleToggleChange} />
                )}
              </div>
            </div>
            <div className={cx('w-100', !showEmbedCodeView ? 'd-none' : '')}>
              <EmbedCode {...{ product, showEmbedCodeView, trackingEnable }} />
            </div>
          </>
        )}
      </div>
    </InfoDialogUI>
  );
};

export const SuccessModal = (props) => {
  const dispatch = useDispatch()
  const { isGuestUser } = useUserContext();
  const isUpgradePopup = props.list?.isUpgradePopup
  const isEditType = +props?.list?.accessType === PRODUCT_PAGE_SHARE_ACCESS?.CAN_EDIT

  const handleShowListMemberName = (data = []) => {
    const emailList = data
      .map((item) => item?.email || item?.description || item?.organization_owner_email)
      .filter((email) => email) // Remove undefined/null values
      .join(', ');
    return emailList;
  }

  const contactSupport = () => {
    dispatch(setContactFormDialogOpen(true));
  };

  return (
    <div className={styles.successContainer}>
      <p>
        <PaymentDoneIcon />
      </p>
      <h2>Invite sent successfully!</h2>
      <div className={styles.subDescription}>
        {isUpgradePopup ? (
          <>
            <p>
              {`${handleShowListMemberName(
                props?.list?.list || []
              )} has been successfully invited to ${isEditType ? 'edit' : 'view'} the `}
              <strong>{props?.name}</strong>.
            </p>
            <p>
              {`However, they won’t be able to edit as editor seats not available on your plan.`}
            </p>
          </>
        ) : (
          <>
            <p>
              {`${handleShowListMemberName(
                props?.list?.list || []
              )} has been successfully invited to ${isEditType ? 'edit' : 'view'} the `}
              <strong>{props?.name}</strong>.
            </p>
          </>
        )}
      </div>
      <div className={styles.actionButtonContainer}>
        <BigButton
          className={`keep-text ${styles.okayBtn}`}
          onClick={() => isUpgradePopup && !isGuestUser() ? contactSupport() : props?.handleClose?.()}
          disabled={false}
          buttonTitle={isUpgradePopup && !isGuestUser() ? 'Need editor seats? Submit a ticket!' : 'Okay'}
        />
      </div>
    </div>
  );
};
